export enum RegisterStepFourResponse {
  DEFAULT,
}
